<template>
  <div class="swiper-container">
    <ol class="breadcrumb swiper-no-swiping position-fixed"></ol>
    <!-- Additional required wrapper -->
    <div class="swiper-wrapper">
      <!-- Slide 1 -->
      <div class="swiper-slide overflow-auto swiper-no-swiping" data-title="Tema 1: Analogías entre figuras / pág. 1">
        <b-container>
            <b-row class="mt-5 pt-3"> 
                <b-col>
                    <h2 class="mt-5">1. Analogías entre figuras</h2>
                </b-col>
            </b-row>

            <b-row> 
                <b-col lg="7" cols="12">
                    <b-row>
                        <b-col md="9" cols="12" order="2" order-md="1">
                            <h6 class="font-italic text-center mt-4">Reproduzca el audio para escuchar una breve introducción al tema 1.
                            </h6>
                            <audio controls class="w-100 my-3" controlsList="nodownload">
                                <source src="recursos/audio/FM_U2_T1_slide14.mp3" type="audio/mp3" />
                            </audio>
                        </b-col>
                        <b-col md="3" cols="8" offset="2" offset-md="0" order="1" order-lg="2">
                            <img src="recursos/img/imgAudio.png" class="img-fluid d-flex mx-auto mb-3" alt="Imagen de Audio">
                            <h6 class="text-center">Adaptada de freepik (2019)</h6>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-container>

        <b-container fluid>
            <b-row>
                <b-col cols="12" class="Fondo-T1"></b-col>
                <b-col cols="12">
                    <p class="text-center mr-3 txtfiguras mt-2">Adaptada de Oladimeji Ajegbile (2019)</p>
                </b-col>
            </b-row>
        </b-container>

        <b-container>
            <b-row align-h="center">
                <b-col lg="7" cols="12">
                    <ul>
                        <li>
                        <p class="mb-0">En los problemas de analogías entre figuras, se presentan
                            dos figuras que guardan una relación entre sí.</p>
                        </li>
                        <li>
                        <p class="mb-0">Luego, se da una tercera figura, la cual mantiene, con una
                            cuarta figura, la misma relación que las dos figuras
                            anteriores.</p>
                        </li>
                        <li>
                        <p class="mb-0">El objetivo es encontrar esa cuarta figura que completa el
                            patrón similar, a partir del análisis de las relaciones que
                            presentan las otras figuras. Para este procedimiento, se
                            tendrá en cuenta la siguiente terminología:</p>
                        </li>
                    </ul>
                    <div class="Fondo4Ppal p-3 rounded mb-3">
                        <p class="mb-0 text-white">
                        Si 𝑎 y 𝑏 son dos figuras que guardan la misma relación, se
                        escribe: 𝒂:𝒃
                        </p>
                    </div>
                    <p>Esto se lee “𝒂 es a 𝒃”.</p>
                    <p>Igualmente, si la relación 𝑎:𝑏 sigue el mismo patrón de otra
                        relación 𝑐:𝑑, se escribe: 𝒂:𝒃∷𝒄:𝒅</p>
                    <p>Lo anterior se lee “𝒂 es a 𝒃 como 𝒄 es a 𝒅”.</p>
                </b-col>
            </b-row>
            <b-row class="mb-5" align-h="center"> 
                <b-col lg="8" cols="12" class="mb-4">
                   <b-row class="mt-3 cuadroGAVI2">
                       <b-col md="3" cols="12">
                           <b-img src="recursos/img/GAVI/Analicemos_la_operación.png" class="d-flex mx-auto" fluid alt="GAVI-GUIA DE APOYO VIRTUAL - UNIDAD VIRTUAL ITM"></b-img>
                       </b-col>
                       <b-col md="9" cols="12">
                            <p class="tal color4Ppal">Apliquemos un ejemplo</p>
                            <p>Te invito a que observes los siguientes ejemplos que se
                                presentan para que profundices en el tema abordado.</p>
                            <button class="btn BtnPrincipal d-flex mx-auto my-4" onClick="javascript:window.open('recursos/docs/EjemplosAnalogiasEntreFiguras.pdf', '_blank');">Haz clic para ver los ejemplos</button>
                       </b-col>
                   </b-row>
                </b-col>
            </b-row>
        </b-container>
      </div>
      <!-- Slide 1 -->
    </div>
    <Modales/>
  </div>
</template>

<script>
import { SwiperController } from "../assets/RecursosITM/js/Swiper";

import Modales from "@/components/Modales";

export default {
  name: "Tema1",

  mounted() {
    SwiperController(), (document.title = this.$route.meta.title);
  },

  components: {
    Modales,
  },
};
</script>